import { ChevronDown, Eye, FileText, Files, List } from 'lucide-react';
import { Button } from '@/components/ui/NewButton';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

type BundleToolbarProps = {
  hasFiles: boolean;
  onPreview?: () => void;
  previewLoading?: boolean;
  onPreviewIndex?: () => void;
  previewIndexLoading?: boolean;
  onGenerate?: () => void;
  generateLoading?: boolean;
  onGeneratedDocs: () => void;
};

export const BundleToolbar = ({
  hasFiles,
  onPreview,
  previewLoading,
  onPreviewIndex,
  previewIndexLoading,
  onGenerate,
  generateLoading,
  onGeneratedDocs,
}: BundleToolbarProps) => {
  const previewBlocked = !hasFiles;
  const anyLoading = previewLoading || previewIndexLoading || generateLoading;

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" loading={anyLoading} type="button">
          <Eye />
          Preview
          <ChevronDown className="opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {onPreview && (
          <DropdownMenuItem disabled={previewBlocked || previewLoading} onSelect={() => onPreview?.()}>
            <Eye />
            Preview
          </DropdownMenuItem>
        )}
        {onPreviewIndex && (
          <DropdownMenuItem disabled={previewBlocked || previewIndexLoading} onSelect={() => onPreviewIndex?.()}>
            <List />
            Preview Index
          </DropdownMenuItem>
        )}
        {onGenerate && (
          <DropdownMenuItem disabled={previewBlocked || generateLoading} onSelect={() => onGenerate?.()}>
            <FileText />
            Generate
          </DropdownMenuItem>
        )}
        <DropdownMenuItem onSelect={onGeneratedDocs}>
          <Files />
          Generated Docs
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
